<template>
  <CheckoutSection>
    <template #header>{{ $t('pages.checkout.digital_section_title') }}</template>
    <CheckoutCartItem v-for="item in cartDigitalItems" :key="item.id">
      <template #headerTitle>{{ item.event_name }}</template>
      <template #headerSubtitle>
        {{ $t('pages.checkout.summary_picacode') }} <span class="code">{{ item.picacode }}</span>
      </template>
      <template #console>
        <!--        <b-button v-if="item.checkin.can_redeem_voucher && !item.checkin.voucher_code"
                          @click="$emit('open-modal-voucher', item.checkin.id)" class="text-uppercase"
                          size="sm" variant="dark" v-b-tooltip.hover :title="$t('pages.checkout.btn_add_voucher_tooltip')">
                  {{ $t('pages.checkout.btn_add_voucher') }}
                </b-button>
               -->
        <router-link :to="{ name: 'checkins-detail', params: { picacode: item.picacode }}" class="rounded-icon"
                     :title="$t('pages.checkout.action_edit_item')">
          <Icon name="edit" width="20" class="text-secondary"/>
        </router-link>
        <a href="#" @click.prevent="openModalConfirm(item.id)" class="rounded-icon"
           :title="$t('pages.checkout.action_delete_item')">
          <Icon name="trash" width="20" class="text-secondary"/>
        </a>
      </template>
      <div class="cart-item--content">
        <swiper-slider :slides-per-view="4.5"
                       :space-between="16"
                       :slides-per-group="2"
                       :breakpoints="cartSliderBreakpoints"
                       :loop="false"
                       :lazy="false"
                       css-mode
                       :simulate-touch="false"
                       :selected-index="0"
                       :extra-class="'slider-cart'">
          <template v-slot:slides>
            <div class="swiper-slide" v-for="media in item.medias" :key="media.id">
              <div class="position-relative">
                <b-link @click="openModalConfirm(item.id, media.id)" class="cart-item--delete">
                  <icon name="closeCircle" width="24"/>
                </b-link>
                <div class="cart-item--slide">
                  <div class="cart-item--image-container" :class="{'video': media.media_type===mediaTypes.VIDEO}">
                    <img :src="media.media_url" alt="" class="cart-item--image">
                    <icon name="play" width="20" class="play" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </swiper-slider>
      </div>

      <template #footerItems v-if="item.order_type.includes(orderTypes.PHOTOLIST)">
          <span>
              {{ $tc('pages.checkout.digital_amount_n_photos', item.media_ids.length) }}
          </span>
      </template>
      <template #footerItems v-else-if="item.order_type.includes(orderTypes.PHOTOPACKAGE)">
        {{ $t('pages.checkout.digital_amount_purchased_items') }}
      </template>
      <template #footerPrice>
        <div> {{ item.price_formatted }}</div>
        <del v-if="item.price !== item.price_original" class="pr-2 text-primary d-block"
             v-b-tooltip.hover :title="item.checkin.voucher_code">
          {{ item.price_original_formatted }}
        </del>
      </template>
    </CheckoutCartItem>

    <ModalCheckoutRemoveDigitalItem :modal-id="modalRemoveItemId" @confirm="confirmDeletion"/>
  </CheckoutSection>
</template>


<script>
import ModalCheckoutRemoveDigitalItem from '@/components/ModalCheckoutRemoveDigitalItem'
import CheckoutSection from '@/components/CheckoutSection'
import CheckoutCartItem from '@/components/CheckoutCartItem'
import SwiperSlider from "@/components/SwiperSlider.vue";
import {mapActions, mapGetters} from "vuex";
import {orderTypes} from "@/domain/cart/constants";
import {mediaTypes} from "@/domain/galleries/constants";

export default {
  name: 'DigitalItems',
  components: {
    SwiperSlider,
    CheckoutSection,
    CheckoutCartItem,
    ModalCheckoutRemoveDigitalItem
  },

  data() {
    return {
      digitalItemId: null,
      photoId: null,
      cartSliderBreakpoints: {
        140: {
          slidesPerView: 2.5,
          slidesPerGroup: 1
        },
        780: {
          slidesPerView: 2.5,
          slidesPerGroup: 1
        },
        1024: {
          slidesPerView: 3.5,
          slidesPerGroup: 1

        },
        1280: {
          slidesPerView: 4.5,
          slidesPerGroup: 2
        }
      }
    }
  },

  computed: {
    mediaTypes() {
      return mediaTypes
    },
    ...mapGetters('cartDigitalItems', [
      'cartDigitalItems',
      'mediaInCartCount'
    ]),
    orderTypes() {
      return orderTypes
    },
  },

  created() {
    this.modalRemoveItemId = 'modal-remove-digital-item'
  },

  methods: {
    ...mapActions('cartDigitalItems', [
      'removeMediasFromDigitalItem',
      'removeDigitalItem',
      'fetchTotalCartItems',
      'fetchDigitalItemsTotals']),

    openModalConfirm(itemId, photoId) {
      this.digitalItemId = itemId
      this.photoId = photoId
      this.$bvModal.show(this.modalRemoveItemId, this.photoId)
    },
    async confirmDeletion() {
      // if there is only one media in the digital item, remove the entire digital item
      const mediaCount = this.mediaInCartCount(this.digitalItemId)
      if (this.digitalItemId && this.photoId && mediaCount > 1) {
        const params = {'media_ids': [this.photoId]}
        await this.removeMediasFromDigitalItem({
          digitalItemId: this.digitalItemId,
          params: params
        })
      } else {
        await this.removeDigitalItem(this.digitalItemId)
      }

      await this.fetchDigitalItemsTotals()
      await this.fetchTotalCartItems()

      this.$bvToast.toast(this.$t('notifications.item_removed_from_cart'))
    }
  }
}
</script>
